const getters = {
  common: (state) => state.common,
  loading: (state) => state.loading,
};

export default getters;
